import {
  Card,
  CardContent,
  Chip,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import DateTimePickerComponent from "components/datePicker/DateTimePicker.component";
import React from "react";
import { DateTime } from "luxon";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useTranslation } from "react-i18next";

const SelectDateStartAndEndComponent = ({
  onChangeValueDate = () => { },
  onChangeDateStart = () => { },
  onChangeDateEnd = () => { },
  onDownload = () => { },
  valueData,
  dateStart,
  dateEnd,
  download = false,
}) => {
  const { t } = useTranslation()
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Card sx={{ width: "100%" }}>
      <CardContent
        sx={{ "&.MuiCardContent-root": { pt: 0, pb: 0.6, pl: 1.6, pr: 1.6 } }}
      >
        <Grid container display="flex" alignItems="end" >
          <Grid
            item
            container
            xs={download ? 10 : 12}
            sm={download ? 11 : 12}
            md={download ? 11 : 12}
            lg={download ? 11.2 : 12}
            spacing={matchesSM ? 0 : 1.5}
            display='flex' alignItems="center"
          >
            <Grid
              item
              container
              xs={12}
              sm={4}
              md={4}
              lg={3}
              spacing={2}
              display="flex"
              alignItems="center"
              mt={matchesSM ? 1 : 0}
            >
              <Grid item xs="auto" sm={6} md={6} lg={6}
                mb={1} display='flex' alignItems="center">
                <Typography variant="h3" align="left" sx={{ fontSize: 18 }}>
                  {t('Data relating to')}
                </Typography>
              </Grid>

              <Grid item xs sm={6} md={6} lg={6}
                mb={1}
                display='flex' alignItems="center">
                <Chip
                  label={t('Last 24 hours')}
                  color="primary"
                  onClick={valueData === "24h" ? () => { } : () => onChangeValueDate("24h")}
                  variant={valueData === "24h" ? "filled" : "outlined"}
                />
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              sm={4}
              md={4}
              lg={4.5}
              display="flex"
              justifyContent="center"
            >
              <DateTimePickerComponent
                label={t('Start date and time')}
                value={dateStart}
                setValue={onChangeDateStart}
                // maxDateTime={addDays(new Date(), 1)}
                maxDateTime={DateTime.now().plus({ days: 1 })}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4} lg={4.5}>
              <DateTimePickerComponent
                value={dateEnd}
                setValue={onChangeDateEnd}
                label={t('End date and time')}
                minDateTime={dateStart}
                // maxDateTime={addDays(new Date(), 1)}
                maxDateTime={DateTime.now().plus({ days: 1 })}
              />
            </Grid>
          </Grid>

          {!!download && <Grid
            item
            xs={2}
            sm={1}
            md={1}
            lg={0.8}
            justifyContent="center"
            display="flex"
            mb={1.3}
          >
            <IconButton
              onClick={() => onDownload()}
              sx={{
                backgroundColor: theme.palette.primary.main,
                borderRadius: 2,
              }}
            >
              <FileDownloadIcon
                sx={{
                  color: "white",
                  "&:hover": { color: theme.palette.primary.main },
                }}
                fontSize="small"
              />
            </IconButton>
          </Grid>}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default SelectDateStartAndEndComponent;
